import { create } from 'jss'
import preset from 'jss-preset-default'

const jssInstance = create(preset())
jssInstance.options.insertionPoint = 'token-portal-insertion-point'

export default function(styles, options: {}){
  const {classes} = jssInstance.createStyleSheet(styles, options).attach()
  const styleFunc = function(...args){
    let res = args.map(arg => {
      if(typeof arg === 'string'){
        return classes[arg]
      }
      else if(typeof arg === 'object'){
        return Object.entries(arg).map(([key, val]) => {
          return val !== false ? classes[key] : ''
        }).join(' ')
      }
      return []
    }).join(' ')
    return res
  }
  Object.keys(classes).forEach(key => styleFunc[key] = classes[key])
  styleFunc.source = styles
  return styleFunc
}
